import Viewer from './Viewer';
import { connect } from 'react-redux';
import {
  setCameraMode,
  setDocumentDataUrl,
  removeDocumentPage,
  setDocumentStatus,
  shareActiveDocumentState
} from '../../redux/actions/rootAction';
import { setAttachmentPrinted } from '../../redux/actions/rootAction';
import withDocumentCommon from '../helpers/withDocumentCommon';
import { DOC_TYPE_IMMEDIATE_CONFIRMATION } from '../helpers/utils';

const mapStateToProps = (state, ownProps) => {
  const requestedDocument = ownProps.document || {
    id: 'fake_document',
    attachment: [],
    attributes: {}
  };
  const documentStatus = state.documentsStatus.get(requestedDocument.id);
  return {
    document: requestedDocument,
    downloadRequired:
      requestedDocument.attributes.downloadRequired &&
      !documentStatus?.downloaded &&
      !requestedDocument.submitted,
    documentStatus: documentStatus,
    scrollContainer: ownProps.scrollContainer,
    confirmed:
      documentStatus?.confirmed ||
      documentStatus?.read ||
      requestedDocument.state === 'ACCEPTED',
    scannedPages: state.scannedDocuments.get(requestedDocument?.id),
    screenSize: {
      width: window.innerWidth || document.documentElement.clientWidth,
      height: window.innerHeight || document.documentElement.clientHeight
    }
  };
};

const mapDispatchToProps = dispatch => ({
  shareActiveDocumentState: payload =>
    dispatch(
      shareActiveDocumentState(DOC_TYPE_IMMEDIATE_CONFIRMATION, payload)
    ),
  setAttachmentPrinted: (documentId, as) =>
    dispatch(setAttachmentPrinted(documentId, as)),
  setCameraMode: as => dispatch(setCameraMode(as)),
  removeDocumentPage: (documentId, pageId) =>
    dispatch(removeDocumentPage(documentId, pageId)),
  setDocumentDataUrl: (documentId, pageId, dataUrl) =>
    dispatch(setDocumentDataUrl(documentId, pageId, dataUrl)),
  setDocumentStatus: (documentId, status) =>
    dispatch(setDocumentStatus(documentId, status))
});

export default withDocumentCommon(
  connect(mapStateToProps, mapDispatchToProps)(Viewer)
);
